// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved. // SPDX-License-Identifier: MIT-0
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "@awsui/global-styles/index.css";
import { Amplify } from "aws-amplify";
import awsconfig from "./aws-exports";
Amplify.configure(awsconfig);

// Cytactic: opt in to the Cloudscape "visual refresh" theme. Without this class the
// components render in the 2021-era classic theme, which is what makes the stock app look
// dated. Purely presentational -- remove this one line to go back. `awsui-dark-mode` on the
// same element switches to dark, if we ever want it.
document.body.classList.add("awsui-visual-refresh");

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
